import { IHealthAndSafetyDashReports } from './../../shared/interfaces/h-s-dash-reports';
import { LocalDb } from './database.service';
import { Injectable } from '@angular/core';
import Dexie from 'dexie';

export interface HealthAndSafetyDashReportsWithId extends IHealthAndSafetyDashReports {
  id: number;
}

@Injectable()
export class HealthAndSafetyDashReportsService {
  table: Dexie.Table<HealthAndSafetyDashReportsWithId, number>;

  constructor(private readonly localDb: LocalDb) {
    this.table = this.localDb.table('healthAndSafetyDashReports');
  }

  get(id) {
    return this.table.get(id);
  }

  getAll() {
    return this.table.toArray();
  }

  add(data, id) {
    return this.table.add(data, id);
  }

  put(data, id) {
    return this.table.put(data, id);
  }

  update(id, data) {
    return this.table.update(id, data);
  }

  remove(id) {
    return this.table.delete(id);
  }

  clear() {
    return this.table.clear();
  }
}
